import React, { useState } from 'react'
import { Autocomplete } from 'components/forms/autocomplete/DPLAutocomplete'

export interface ISelectedAutosuggest {
  value: string
  fullSelection: {
    name: string
  }
}

export type IFieldValue = {
  field: string
  value?: string
}

interface IAutocompleteDisplayProps {
  onChange: (value: IFieldValue) => void
  type: string
  dataTest?: string
  label?: string
  id?: string
  large?: boolean
  placeholder?: string
  currentValue?: string
  hasValue?: boolean
  field: string
  className?: string
}

/**
 * AutocompleteDisplay Component
 * Wrapper around DPLAutocomplete that extracts selected display state
 *
 * @param onChange - Yields `field` and `value` if `field` is defined. O/w returns 'value'
 * @param field - The field name of the input
 * @param hasValue - Display if there is a value
 * @param currentValue - Display saved value
 * @param className - Additional classes on div wrapper
 */
const AutocompleteDisplay = ({
  className = '',
  currentValue,
  dataTest,
  field,
  hasValue = true,
  id,
  label,
  large,
  onChange,
  placeholder,
  type,
}: IAutocompleteDisplayProps) => {
  const [displayName, setDisplayName] = useState(currentValue)

  const onChangeHandler = ({ fullSelection, value }: ISelectedAutosuggest) => {
    if (value) {
      setDisplayName(fullSelection?.name)
    }
    onChange({ field, value: value || undefined })
  }

  return (
    <div className={className}>
      <Autocomplete
        onChange={onChangeHandler}
        value={hasValue && displayName}
        type={type}
        label={label}
        field={field}
        id={id}
        dataTest={dataTest}
        large={large}
        placeholder={placeholder}
      />
    </div>
  )
}

export default AutocompleteDisplay
